module.exports = __webpack_public_path__ + "static/media/nova_poshta.146feee6.svg";